import React from "react";
import styled from "styled-components";
import { useCardElement } from "../../hooks/index";

const Footer = styled.div`
    margin-top: 0px;
    padding-right: 10px;
    padding-left: 10px;
    padding-bottom: 20px;
`;

export default (props) => {
  const ref = React.useRef(null);
  const [Child, setChild] = React.useState(<React.Fragment />);
  const renderCardElement = useCardElement();

  React.useEffect(() => {
    const footer = renderCardElement(props.footer);
    setChild(footer);
  }, [ref.current]);
  if(!Child){
    return <React.Fragment />
  }
  return <Footer ref={ref}>{Child}</Footer>;
};



// WEBPACK FOOTER //
// ./src/_components/Card/components/Footer/index.jsx